import React from 'react';
import * as R from 'ramda';
import {useTranslation} from 'react-i18next';
import {maybe, toDollar} from '@/util';

const showField = item => {
  const checkVal = R.propOr(true, 'checkVal')(item);
  return maybe(checkVal).map(() => (
    <tr key={item.name}>
      <th>{item.name}</th>
      <td>{item.displayVal}</td>
    </tr>
  ));
};

const InvestmentLinkOverview = ({plan}) => {
  const {t: tr} = useTranslation('statements');
  const fields = R.map(R.zipObj(['name', 'displayVal', 'checkVal']))([
    [tr('policy_owner'), plan.policyOwner],
    [tr('address'), R.join(' ', plan.address)], // {/* weird contact number for 9913676 */}
    [tr('contact_no'), plan.contactNo],
    [tr('email'), plan.email],
    [tr('policy_no'), plan.planNo],
    [
      R.join(' / ', [tr('plan_start_date'), tr('plan_term')]),
      R.join('', [plan.commenceDate, ' / ', plan.policyTerm]),
    ],
    [
      R.join(' / ', [tr('payment_freq'), tr('pay_term')]),
      R.join('', [plan.paymentFrequency, ' / ', plan.payTerm]),
    ],
    [tr('payment_method'), plan.paymentMethod],
    [tr('policy_status'), plan.policyStatus],
    [tr('portfolio_type'), plan.portfolioType],
    [tr('policy_plan_Name'), plan.productName],
    [tr('joint_policy_Owner'), plan.jointOwner, plan.jointOwner],
    [tr('name_of_insured'), plan.insured, plan.insured],
    [tr('name_of_beneficiary'), plan.beneficiary, plan.beneficiary],
    [
      tr('modal_premium'),
      R.join(' ', [plan.currency, toDollar(plan.modalPremium)]),
    ],
    [
      tr('total_premium_paid'),
      R.join(' ', [plan.currency, toDollar(plan.totalPremiumPaid)]),
      plan.totalPremiumPaid,
    ],
    [
      tr('estimated_premium_and_levy_amount'),
      toDollar(plan.estimatedPremiumAndLevyAmount),
      plan.estimatedPremiumAndLevyAmount,
    ],
    [
      tr('next_contribute_due_date'),
      plan.nextContributeDueOn,
      plan.nextContributeDueOn,
    ],
    [
      tr('pending_transaction_amount'),
      R.join(' ', [plan.currency, toDollar(plan.pendingTranAmount)]),
      plan.pendingTranAmount,
    ],
    [
      tr('withdrawal_amount'),
      R.join(' ', [
        plan.totalWithdrawalCurrency,
        toDollar(toDollar(plan.totalWithdrawalAmount)),
      ]),
      plan.totalWithdrawalAmount,
    ],
  ]);

  const itemlist = R.map(item => showField(item))(fields);

  return (
    <table className='info'>
      <tbody>{itemlist}</tbody>
    </table>
  );
};

export default InvestmentLinkOverview;
